
import ToggleSwitch from "components/actions/ToggleSwitch";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import ModalWrapper from 'components/ModalWrapper'
import { useTranslation } from "react-i18next";
import TimePicker from "components/actions/TimePicker";
import TextArea from "components/forms/TextArea";
import Input from "components/forms/Input";
import { pickChannel } from ".";
import PropTypes from 'prop-types';

const AddNotification = ({ disabled, onDataSubmit }) => {

  const { t } = useTranslation();
  const { register, handleSubmit, formState: { errors } } = useForm({ mode: 'onChange' });
  const [missingChannel, setMissingChannel] = useState(false)
  const [isOpen, setIsOpen] = useState(false);
  const [whatsAppChannel, setWhatsAppChannel] = useState(true)
  const [messengerChannel, setMessengerChannel] = useState(true)
  const [selectedTime, setSelectedTime] = useState()

  const onSubmit = (data) => {
    if (whatsAppChannel || messengerChannel) {
      onDataSubmit(
        {
          "notification": {
            "title": data?.notification_title,
            "text": data?.notification_text
          },
          "channels": [
            { _id: "1", "label": "Whatsapp", "enabled": whatsAppChannel },
            { _id: "2", "label": "Messenger", "enabled": messengerChannel }
          ],
          "schedule": { "time": selectedTime || new Date() }
        });
      setIsOpen(false);
    }


  }
  useEffect(() => {
    setMissingChannel(!(whatsAppChannel || messengerChannel))
  }, [whatsAppChannel, messengerChannel])


  useEffect(() => {
  }, [isOpen])


  return (
    <>
      <button disabled={!!disabled}
        className={`shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2  transition duration-150 ease-in-out 
              rounded  px-4 py-2 text-sm ${disabled ? 'bg-gray-200 text-gray-400' : 'text-white bg-blue-500 focus:ring-blue-700 hover:bg-blue-600'}`}
        onClick={() => setIsOpen(true)}>
        + {t('actions.new_notification')}
      </button>

      <ModalWrapper
        open={isOpen}
        setOpen={setIsOpen}
        title={'New notification'}
      >
        <div className="w-[480px] xl:w[560px] p-2">
          {/* 1. Time  */}
          <div className="pb-4 border-b" >
            <div className="capitalize text-gray-800 font-lg font-bold tracking-normal leading-tight  py-2">
              {t('form.scheduling')}
            </div>
            <div className="flex justify-between items-center">
              <div > {t('form.select_time')} </div>
              <TimePicker onDataChange={setSelectedTime} />
            </div>

          </div>


          <form className=" overflow-auto" method="POST" onSubmit={handleSubmit(onSubmit)}>


            <div className="py-4 border-b">
              <div className="capitalize text-gray-800 font-lg font-bold tracking-normal leading-tight  py-1">
                {t('campaigns.notification')}
              </div>
              <Input
                label={t('form.notification_title')}
                placeholder={t('actions.enter') + " " + t('form.notification_title')}
                id={"notification_title"}
                maxLength={65}
                register={register("notification_title", {
                  required: t('form.error_notification_title'),
                  maxLength: { value: 65, message: t('form.error_max_length', { max: 65 }) }
                })}
                error={errors.notification_title}
                className="my-2"
              />

              <TextArea
                label={t('form.notification_text')}
                placeholder={t('actions.enter') + " " + t('form.notification_text')}
                id={"notification_text"}
                maxLength={1500}
                register={register("notification_text", {
                  required: t('form.error_notification_text'),
                  maxLength: { value: 1500, message: t('form.error_max_length', { max: 1500 }) }
                })}
                error={errors.notification_text}
                className="my-2"
              />

            </div>


            {/* 4. Step | Channels */}
            <div className="py-4 " >

              <div className="capitalize text-gray-800 font-lg font-bold tracking-normal leading-tight py-2 border-separate">
                {t('campaigns.channels')}
              </div>

              <div className="flex justify-between my-2 border rounded-md p-4">
                <div className="flex items-center">
                  <span className="text-xl"> {pickChannel("1", whatsAppChannel)}</span>
                  <span className="text-gray-800 text-sm font-medium  leading-tight tracking-normal">{t('social.whatsapp')}</span>
                </div>
                <ToggleSwitch isEnabled={setWhatsAppChannel} enabled={whatsAppChannel} />
              </div>

              <div className="flex justify-between my-2 border rounded-md p-4">
                <div className="flex items-center">
                  <span className="text-xl"> {pickChannel("2", messengerChannel)}</span>
                  <span className="text-gray-800 text-sm font-medium  leading-tight tracking-normal">{t('social.fb_messenger')}</span>
                </div>
                <ToggleSwitch isEnabled={setMessengerChannel} enabled={messengerChannel} />
              </div>

              {missingChannel && <p className="text-red-500 text-xs">{t('form.error_channels')}</p>}
            </div>




            {/* Actions  */}
            <div className="flex items-center justify-end p-2">

              <input type='button' value={t('actions.cancel')} onClick={() => setIsOpen(false)}
                className='capitalize bg-gray-100 rounded shadow px-4 py-2 bottom-2 mx-2 border-1 border-gray-500'
              />
              <input
                className='capitalize bg-blue-500 text-white rounded shadow-md px-4 py-2'
                type="submit" value={t('actions.send')} />
            </div>

          </form>

        </div>

      </ModalWrapper>
    </>

  );

}


AddNotification.propTypes = {
  disabled: PropTypes.bool,
  onDataSubmit: PropTypes.func.isRequired,
};

export default AddNotification;




